package pt.at.oss.kotlin.manual.enumeration

/**
 * Created by Pedro Alfaiate on 14/05/2020.
 */
enum class AddressType(val value: String) {
    STRUCTURED("structured"),
    FREE_TEXT("freeText")
}
